/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface UnitDto
 */
export interface UnitDto {
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof UnitDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UnitDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof UnitDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof UnitDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnitDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnitDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof UnitDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof UnitDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof UnitDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UnitDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof UnitDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof UnitDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    abbreviation: string;
    /**
     * 
     * @type {string}
     * @memberof UnitDto
     */
    $type?: UnitDtoTypeEnum;
}


/**
 * @export
 */
export const UnitDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoUnitDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.UnitDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UnitDtoTypeEnum = typeof UnitDtoTypeEnum[keyof typeof UnitDtoTypeEnum];



/**
 * Check if a given object implements the UnitDto interface.
 */
export function instanceOfUnitDto(value?: unknown): value is UnitDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UnitDtoTypeEnum)[0];
}

export function UnitDtoFromJSON(json: any): UnitDto {
    return UnitDtoFromJSONTyped(json, false);
}

export function UnitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'abbreviation': json['abbreviation'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function UnitDtoToJSON(value?: Omit<UnitDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value['state']),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'abbreviation': value['abbreviation'],
        '$type': value['$type'],
    });
}

